import styled, { css, keyframes } from 'styled-components';

import {
    BUTTON_CONTENT_BASE,
    CONTENT_BASE,
    NEGATIVE_BASE,
    POSITIVE_BASE,
    PRIMARY_BASE,
    PRIMARY_TEXT_LINK_BASE
} from '@amzn/ring-common-style-library/lib/colors';

import {
    BODY_NORMAL_MEDIUM,
    TEXTLINK_SMALL_MEDIUM,
} from '@amzn/ring-common-style-library/lib/typography';


const slideInFromBottom = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOutToBottom = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;


const typeStyles = {
    default: css`
        border: 1px solid ${PRIMARY_BASE};
        color: ${PRIMARY_TEXT_LINK_BASE};
    `,
    negative: css`
        border: 1px solid ${NEGATIVE_BASE};
        color: ${NEGATIVE_BASE};
    `,
    positive: css`
        border: 1px solid ${POSITIVE_BASE};
        color: ${POSITIVE_BASE};
    `,
};

const NotificationCard = styled.div<{
    type: 'default' | 'negative' | 'positive'
    isVisible: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    padding: 16px;
    gap: 4px;

    border-radius: 8px;
    ${({ type }) => typeStyles[type]}
    background: ${BUTTON_CONTENT_BASE};

    animation: ${({ isVisible }) => (isVisible ? slideInFromBottom : slideOutToBottom)} 0.8s ease forwards;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const HeaderText = styled.div`
    ${BODY_NORMAL_MEDIUM};
    color: ${CONTENT_BASE};
`;

const CloseButton = styled.div`
    width: 24px;
    height: 24px;

    cursor: pointer;
`;

const ExpandLink = styled.div`
    ${TEXTLINK_SMALL_MEDIUM}
    cursor: pointer;
`;

export default {
    NotificationCard,
    Header,
    HeaderText,
    ExpandLink,
    CloseButton,
}